export const FORECASTERS = 'forecaster@avalanche.ca'
export const INFO = 'info@avalanche.ca'
export const SUPPORT = 'support@avalanche.ca'
